import { useState } from "react"
import { useFirestore, useFirestoreCollectionData } from "reactfire"
import {
  collection, doc, deleteDoc, query, where,
  getDocs, updateDoc, addDoc,
} from "firebase/firestore"
import { UNIDADES, UNIDADES_CON_ROL } from "../config/unidades"
import { useActividad } from "../hooks/useActividad"

const ESTADO_CONFIG = {
  pagado:    { label: "Pagado",    clase: "badge-pagado"    },
  pendiente: { label: "Pendiente", clase: "badge-pendiente" },
  atrasado:  { label: "Atrasado",  clase: "badge-atrasado"  },
  no_aplica: { label: "No aplica", clase: "badge-exento"    },
}
const ESTADOS = ["pendiente", "pagado", "atrasado", "no_aplica"]
const ESTADOS_CON_OBS = ["pendiente", "atrasado"]

const METODOS_PAGO = [
  { value: "",              label: "— Sin especificar —" },
  { value: "efectivo",      label: "💵 Efectivo"         },
  { value: "transferencia", label: "🏦 Transferencia"    },
]

export default function CuotasGlobalesList({ unidadId, puedeEditar }) {
  const firestore = useFirestore()
  const { registrar } = useActividad()

  const { data: cuotas,   status } = useFirestoreCollectionData(
    collection(firestore, "unidades", unidadId, "cuotas"),   { idField: "id" }
  )
  const { data: egresos } = useFirestoreCollectionData(
    collection(firestore, "unidades", unidadId, "egresos"),  { idField: "id" }
  )
  const { data: ingresos } = useFirestoreCollectionData(
    collection(firestore, "unidades", unidadId, "ingresos"), { idField: "id" }
  )

  const [expandida,    setExpandida]    = useState(null)
  const [tabActiva,    setTabActiva]    = useState("ingresos")
  const [modalEgreso,  setModalEgreso]  = useState(false)
  const [modalIngreso, setModalIngreso] = useState(false)
  const [busqCuota,    setBusqCuota]    = useState("")
  const [busqEgreso,   setBusqEgreso]   = useState("")
  const [busqIngreso,  setBusqIngreso]  = useState("")

  const eliminarCuota = async (cuotaId, nombre) => {
    if (!window.confirm("¿Eliminar esta cuota y todos sus estados de pago?")) return
    const snap = await getDocs(
      query(collection(firestore, "unidades", unidadId, "pagos"), where("cuotaId", "==", cuotaId))
    )
    await Promise.all(snap.docs.map(d => deleteDoc(d.ref)))
    await deleteDoc(doc(firestore, "unidades", unidadId, "cuotas", cuotaId))
    await registrar({ accion: "eliminó", entidad: "cuota", nombre, unidadId })
    if (expandida === cuotaId) setExpandida(null)
  }

  const eliminarEgreso = async (eg) => {
    if (!window.confirm("¿Eliminar este egreso?")) return
    await deleteDoc(doc(firestore, "unidades", unidadId, "egresos", eg.id))
    await registrar({ accion: "eliminó", entidad: "egreso", nombre: eg.descripcion, unidadId })
  }

  const eliminarIngreso = async (ing) => {
    if (!window.confirm("¿Eliminar este ingreso extra?")) return
    await deleteDoc(doc(firestore, "unidades", unidadId, "ingresos", ing.id))
    await registrar({ accion: "eliminó", entidad: "ingreso", nombre: ing.descripcion, unidadId })
  }

  if (status === "loading") return <div className="loading">Cargando cuotas...</div>

  const cuotasOrdenadas = [...(cuotas || [])]
    .sort((a, b) => (b.fecha?.seconds || 0) - (a.fecha?.seconds || 0))
    .filter(c => !busqCuota.trim() || c.descripcion?.toLowerCase().includes(busqCuota.trim().toLowerCase()))

  const egresosOrdenados = [...(egresos || [])]
    .sort((a, b) => (b.fecha?.seconds || 0) - (a.fecha?.seconds || 0))
  const totalEgresos = egresosOrdenados.reduce((s, e) => s + (e.monto || 0), 0)
  const egresosFiltrados = egresosOrdenados
    .filter(e => !busqEgreso.trim() || e.descripcion?.toLowerCase().includes(busqEgreso.trim().toLowerCase()))

  const ingresosOrdenados = [...(ingresos || [])]
    .sort((a, b) => (b.fecha?.seconds || 0) - (a.fecha?.seconds || 0))
  const totalIngresos = ingresosOrdenados.reduce((s, i) => s + (i.monto || 0), 0)
  const ingresosFiltrados = ingresosOrdenados
    .filter(i => !busqIngreso.trim() || i.descripcion?.toLowerCase().includes(busqIngreso.trim().toLowerCase()))

  const TABS = [
    { id: "ingresos",       label: "💰 Cuotas" },
    { id: "ingresos_extra", label: "🎁 Ingresos extra" },
    { id: "egresos",        label: "📤 Egresos" },
  ]

  return (
    <div>
      {/* ── Tabs ── */}
      <div style={{ display: "flex", gap: 8, marginBottom: 20, flexWrap: "wrap" }}>
        {TABS.map(t => (
          <button
            key={t.id}
            onClick={() => setTabActiva(t.id)}
            style={{
              padding: "9px 20px", borderRadius: 10, border: "none", cursor: "pointer",
              fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: 14,
              background: tabActiva === t.id ? "var(--verde)" : "var(--verde-suave)",
              color:      tabActiva === t.id ? "#fff"        : "var(--verde)",
              transition: "all 0.15s",
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* ── TAB CUOTAS ── */}
      {tabActiva === "ingresos" && (
        <>
          <Buscador
            valor={busqCuota}
            onChange={v => { setBusqCuota(v); setExpandida(null) }}
            placeholder="Buscar cuota por nombre..."
          />
          {busqCuota && <ContadorResultados n={cuotasOrdenadas.length} />}

          {cuotasOrdenadas.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">{busqCuota ? "🔍" : "💰"}</div>
              <div className="empty-text">
                {busqCuota
                  ? "No se encontraron cuotas con ese nombre."
                  : <>{`No hay cuotas creadas.`}{puedeEditar && <><br />Crea la primera con el botón de arriba.</>}</>
                }
              </div>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {cuotasOrdenadas.map(cuota => (
                <div key={cuota.id} className="card" style={{ padding: 0, overflow: "hidden" }}>
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 14, padding: "16px 20px", cursor: "pointer", userSelect: "none" }}
                    onClick={() => setExpandida(expandida === cuota.id ? null : cuota.id)}
                  >
                    <div style={{
                      width: 40, height: 40, borderRadius: 10, flexShrink: 0, fontSize: 20,
                      background: cuota.tipo === "mensual" ? "var(--verde-suave)" : "#fef3e2",
                      display: "flex", alignItems: "center", justifyContent: "center",
                    }}>
                      {cuota.tipo === "mensual" ? "📅" : "⛺"}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 700, fontSize: 15 }}>
                        <Resaltado texto={cuota.descripcion} busqueda={busqCuota.trim()} />
                      </div>
                      <div style={{ fontSize: 13, color: "var(--gris)", marginTop: 2 }}>
                        {cuota.tipo === "mensual" ? "Mensual" : "Evento"} ·{" "}
                        <strong style={{ color: "var(--verde)" }}>
                          ${(cuota.monto || 0).toLocaleString("es-CL")}
                        </strong>
                      </div>
                    </div>
                    <ResumenEstados unidadId={unidadId} cuotaId={cuota.id} />
                    <div style={{ display: "flex", gap: 6, marginLeft: 8 }}>
                      {puedeEditar && (
                        <button
                          className="btn-icon"
                          onClick={e => { e.stopPropagation(); eliminarCuota(cuota.id, cuota.descripcion) }}
                        >
                          🗑️
                        </button>
                      )}
                      <div style={{
                        width: 28, height: 28, display: "flex", alignItems: "center",
                        justifyContent: "center", color: "var(--gris)", fontSize: 12,
                        transform: expandida === cuota.id ? "rotate(180deg)" : "none",
                        transition: "transform 0.2s",
                      }}>▼</div>
                    </div>
                  </div>
                  {expandida === cuota.id && (
                    <DetallePagos unidadId={unidadId} cuotaId={cuota.id} puedeEditar={puedeEditar} />
                  )}
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {/* ── TAB INGRESOS EXTRA ── */}
      {tabActiva === "ingresos_extra" && (
        <div>
          <div style={{
            background: "#f0fdf4", border: "1px solid #86efac",
            borderRadius: 12, padding: "14px 18px", marginBottom: 20,
            fontSize: 13, color: "#166534", display: "flex", gap: 12, alignItems: "flex-start",
          }}>
            <span style={{ fontSize: 20, flexShrink: 0 }}>💡</span>
            <div>
              Registra aquí dinero que entra a la unidad <strong>sin ser una cuota</strong>: donaciones,
              ventas de productos, rifas, aportes externos, etc.
              Estos montos se suman automáticamente al total recaudado en el resumen financiero.
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, flexWrap: "wrap", gap: 10 }}>
            <div style={{ fontFamily: "'Playfair Display', serif", color: "#166534", fontSize: 20, fontWeight: 700 }}>
              Total ingresos extra: ${totalIngresos.toLocaleString("es-CL")}
            </div>
            {puedeEditar && (
              <button className="btn-primary" onClick={() => setModalIngreso(true)}>
                + Nuevo Ingreso
              </button>
            )}
          </div>

          <Buscador valor={busqIngreso} onChange={setBusqIngreso} placeholder="Buscar por nombre..." />
          {busqIngreso && <ContadorResultados n={ingresosFiltrados.length} />}

          {ingresosFiltrados.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">{busqIngreso ? "🔍" : "🎁"}</div>
              <div className="empty-text">
                {busqIngreso
                  ? "No se encontraron ingresos con ese nombre."
                  : <>{`No hay ingresos extra registrados.`}{puedeEditar && <><br />Agrega el primero con el botón de arriba.</>}</>
                }
              </div>
            </div>
          ) : (
            <div className="tabla-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Nombre / Descripción</th>
                    <th>Monto</th>
                    <th>Fecha</th>
                    {puedeEditar && <th>Acciones</th>}
                  </tr>
                </thead>
                <tbody>
                  {ingresosFiltrados.map(ing => (
                    <tr key={ing.id}>
                      <td style={{ fontWeight: 500 }}>
                        <Resaltado texto={ing.descripcion} busqueda={busqIngreso.trim()} />
                      </td>
                      <td style={{ color: "#166534", fontWeight: 700 }}>
                        +${(ing.monto || 0).toLocaleString("es-CL")}
                      </td>
                      <td style={{ color: "var(--gris)", fontSize: 13 }}>
                        {ing.fecha ? new Date(ing.fecha.seconds * 1000).toLocaleDateString("es-CL") : "—"}
                      </td>
                      {puedeEditar && (
                        <td>
                          <button className="btn-icon" onClick={() => eliminarIngreso(ing)}>🗑️</button>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ── TAB EGRESOS ── */}
      {tabActiva === "egresos" && (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, flexWrap: "wrap", gap: 10 }}>
            <div style={{ fontFamily: "'Playfair Display', serif", color: "var(--rojo)", fontSize: 20, fontWeight: 700 }}>
              Total egresos: ${totalEgresos.toLocaleString("es-CL")}
            </div>
            {puedeEditar && (
              <button className="btn-primary" onClick={() => setModalEgreso(true)}>
                + Nuevo Egreso
              </button>
            )}
          </div>

          <Buscador valor={busqEgreso} onChange={setBusqEgreso} placeholder="Buscar egreso por descripción..." />
          {busqEgreso && <ContadorResultados n={egresosFiltrados.length} />}

          {egresosFiltrados.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">{busqEgreso ? "🔍" : "📤"}</div>
              <div className="empty-text">
                {busqEgreso
                  ? "No se encontraron egresos con esa descripción."
                  : "No hay egresos registrados."
                }
              </div>
            </div>
          ) : (
            <div className="tabla-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Descripción</th>
                    <th>Monto</th>
                    <th>Fecha</th>
                    {puedeEditar && <th>Acciones</th>}
                  </tr>
                </thead>
                <tbody>
                  {egresosFiltrados.map(eg => (
                    <tr key={eg.id}>
                      <td style={{ fontWeight: 500 }}>
                        <Resaltado texto={eg.descripcion} busqueda={busqEgreso.trim()} />
                      </td>
                      <td style={{ color: "var(--rojo)", fontWeight: 700 }}>
                        -${(eg.monto || 0).toLocaleString("es-CL")}
                      </td>
                      <td style={{ color: "var(--gris)", fontSize: 13 }}>
                        {eg.fecha ? new Date(eg.fecha.seconds * 1000).toLocaleDateString("es-CL") : "—"}
                      </td>
                      {puedeEditar && (
                        <td>
                          <button className="btn-icon" onClick={() => eliminarEgreso(eg)}>🗑️</button>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {modalEgreso && (
        <ModalMonto
          titulo="Nuevo Egreso"
          icono="📤"
          placeholder="Ej: Compra de materiales para campamento"
          onGuardar={async (datos) => {
            await addDoc(collection(firestore, "unidades", unidadId, "egresos"), datos)
            await registrar({ accion: "creó", entidad: "egreso", nombre: datos.descripcion, unidadId })
          }}
          onCerrar={() => setModalEgreso(false)}
        />
      )}

      {modalIngreso && (
        <ModalMonto
          titulo="Nuevo Ingreso Extra"
          icono="🎁"
          placeholder="Ej: Donación de apoderado, Venta de rifas..."
          onGuardar={async (datos) => {
            await addDoc(collection(firestore, "unidades", unidadId, "ingresos"), datos)
            await registrar({ accion: "creó", entidad: "ingreso", nombre: datos.descripcion, unidadId })
          }}
          onCerrar={() => setModalIngreso(false)}
        />
      )}
    </div>
  )
}

/* ── Componentes reutilizables ── */

function Buscador({ valor, onChange, placeholder }) {
  return (
    <div style={{ position: "relative", marginBottom: 16 }}>
      <span style={{
        position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)",
        fontSize: 16, pointerEvents: "none", opacity: 0.4,
      }}>🔍</span>
      <input
        className="form-input"
        style={{ paddingLeft: 40, marginBottom: 0 }}
        placeholder={placeholder}
        value={valor}
        onChange={e => onChange(e.target.value)}
      />
      {valor && (
        <button
          onClick={() => onChange("")}
          style={{
            position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)",
            background: "none", border: "none", cursor: "pointer",
            fontSize: 16, color: "var(--gris)", padding: 4,
          }}
        >✕</button>
      )}
    </div>
  )
}

function ContadorResultados({ n }) {
  return (
    <div style={{ fontSize: 13, color: "var(--gris)", marginBottom: 10 }}>
      {n === 0 ? "Sin resultados" : `${n} resultado${n !== 1 ? "s" : ""}`}
    </div>
  )
}

function Resaltado({ texto, busqueda }) {
  if (!busqueda || !texto) return <>{texto}</>
  const idx = texto.toLowerCase().indexOf(busqueda.toLowerCase())
  if (idx === -1) return <>{texto}</>
  return (
    <>
      {texto.slice(0, idx)}
      <mark style={{ background: "#fef08a", color: "inherit", borderRadius: 3, padding: "0 2px" }}>
        {texto.slice(idx, idx + busqueda.length)}
      </mark>
      {texto.slice(idx + busqueda.length)}
    </>
  )
}

function ResumenEstados({ unidadId, cuotaId }) {
  const firestore = useFirestore()
  const { data: pagos, status } = useFirestoreCollectionData(
    query(
      collection(firestore, "unidades", unidadId, "pagos"),
      where("cuotaId", "==", cuotaId)
    ),
    { idField: "id" }
  )
  if (status === "loading" || !pagos) return null
  const total     = pagos.filter(p => p.estado !== "no_aplica").length
  const pagados   = pagos.filter(p => p.estado === "pagado").length
  const atrasados = pagos.filter(p => p.estado === "atrasado").length
  return (
    <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
      <span className="badge badge-pagado">{pagados}/{total} pagados</span>
      {atrasados > 0 && <span className="badge badge-atrasado">{atrasados} atrasados</span>}
    </div>
  )
}

function DetallePagos({ unidadId, cuotaId, puedeEditar }) {
  const firestore = useFirestore()
  const { data: apoderados } = useFirestoreCollectionData(
    collection(firestore, "unidades", unidadId, "apoderados"), { idField: "id" }
  )
  const { data: pagos } = useFirestoreCollectionData(
    query(
      collection(firestore, "unidades", unidadId, "pagos"),
      where("cuotaId", "==", cuotaId)
    ),
    { idField: "id" }
  )
  const [obsLocal, setObsLocal] = useState({})

  const ORDEN_UNIDADES = ["bandada", "manada", "compania", "tropa", "avanzada", "clan"]
  const esConsejo      = UNIDADES_CON_ROL.includes(unidadId)

  const apoderadosActivos = (apoderados || [])
    .filter(a => !a.exento)
    .sort((a, b) => {
      const iA = ORDEN_UNIDADES.indexOf(a.unidadRol)
      const iB = ORDEN_UNIDADES.indexOf(b.unidadRol)
      if (iA !== -1 || iB !== -1) {
        const posA = iA === -1 ? 999 : iA
        const posB = iB === -1 ? 999 : iB
        if (posA !== posB) return posA - posB
      }
      return (a.nombre || "").localeCompare(b.nombre || "", "es")
    })

  const getPago   = id => (pagos || []).find(p => p.apoderadoId === id)
  const getEstado = id => getPago(id)?.estado || "pendiente"
  const getMetodo = id => getPago(id)?.metodoPago || ""
  const getObs    = id => obsLocal[id] !== undefined ? obsLocal[id] : (getPago(id)?.observacion || "")

  const guardarCampo = async (apoderadoId, campos) => {
    const pago = getPago(apoderadoId)
    if (pago) {
      await updateDoc(doc(firestore, "unidades", unidadId, "pagos", pago.id), campos)
    } else {
      await addDoc(collection(firestore, "unidades", unidadId, "pagos"), {
        cuotaId, apoderadoId, estado: "pendiente", observacion: "", metodoPago: "", ...campos,
      })
    }
  }

  const cambiarEstado = async (apoderadoId, nuevoEstado) => {
    const obs = getObs(apoderadoId)
    await guardarCampo(apoderadoId, {
      estado:      nuevoEstado,
      observacion: ESTADOS_CON_OBS.includes(nuevoEstado) ? obs : "",
      metodoPago:  nuevoEstado === "pagado" ? getMetodo(apoderadoId) : "",
    })
    if (!ESTADOS_CON_OBS.includes(nuevoEstado)) {
      setObsLocal(prev => { const n = { ...prev }; delete n[apoderadoId]; return n })
    }
  }

  const guardarObservacion = async (apoderadoId) => {
    await guardarCampo(apoderadoId, { observacion: obsLocal[apoderadoId] ?? "" })
    setObsLocal(prev => { const n = { ...prev }; delete n[apoderadoId]; return n })
  }

  const th = {
    padding: "10px 14px", textAlign: "left", fontSize: 11,
    color: "var(--verde)", textTransform: "uppercase",
    letterSpacing: "0.06em", fontWeight: 700,
  }

  // Construir filas con flatMap para intercalar cabeceras de grupo
  let ultimaUnidad = null
  const filas = apoderadosActivos.flatMap(ap => {
    const estado   = getEstado(ap.id)
    const metodo   = getMetodo(ap.id)
    const obs      = getObs(ap.id)
    const hayLocal = obsLocal[ap.id] !== undefined
    const tieneObs = ESTADOS_CON_OBS.includes(estado)
    const esPagado = estado === "pagado"
    const cfg      = ap.unidadRol ? UNIDADES[ap.unidadRol] : null

    const mostrarCabecera = esConsejo && ap.unidadRol && ap.unidadRol !== ultimaUnidad
    if (mostrarCabecera) ultimaUnidad = ap.unidadRol

    const resultado = []

    if (mostrarCabecera && cfg) {
      resultado.push(
        <tr key={`grupo-${ap.unidadRol}`}>
          <td colSpan={5} style={{
            padding: "8px 14px", background: cfg.bg,
            borderTop: "2px solid var(--gris-borde)",
          }}>
            <span style={{
              fontWeight: 700, fontSize: 12, color: cfg.texto,
              textTransform: "uppercase", letterSpacing: "0.08em",
            }}>
              {cfg.icono} {cfg.nombre}
            </span>
          </td>
        </tr>
      )
    }

    resultado.push(
      <tr key={ap.id} style={{ borderTop: "1px solid var(--gris-borde)" }}>
        <td style={{ padding: "11px 14px", fontWeight: 600, fontSize: 14 }}>{ap.nombre}</td>
        <td style={{ padding: "11px 14px", fontSize: 13, color: "var(--texto-suave)" }}>
          {ap.scouts?.join(", ") || "—"}
        </td>
        <td style={{ padding: "11px 14px" }}>
          {puedeEditar ? (
            <select
              value={estado}
              onChange={e => cambiarEstado(ap.id, e.target.value)}
              className="form-select"
              style={{ width: "auto", padding: "6px 10px", fontSize: 13 }}
            >
              {ESTADOS.map(e => <option key={e} value={e}>{ESTADO_CONFIG[e].label}</option>)}
            </select>
          ) : (
            <span className={`badge ${ESTADO_CONFIG[estado]?.clase}`}>
              {ESTADO_CONFIG[estado]?.label}
            </span>
          )}
        </td>
        <td style={{ padding: "11px 14px", minWidth: 160 }}>
          {esPagado && puedeEditar ? (
            <select
              value={metodo}
              onChange={e => guardarCampo(ap.id, { metodoPago: e.target.value })}
              className="form-select"
              style={{ width: "auto", padding: "6px 10px", fontSize: 13 }}
            >
              {METODOS_PAGO.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
            </select>
          ) : esPagado && metodo ? (
            <span className="badge badge-exento">
              {METODOS_PAGO.find(m => m.value === metodo)?.label || metodo}
            </span>
          ) : (
            <span style={{ color: "var(--gris-borde)", fontSize: 13 }}>—</span>
          )}
        </td>
        <td style={{ padding: "10px 14px", minWidth: 240 }}>
          {tieneObs && puedeEditar ? (
            <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
              <input
                type="text"
                className="form-input"
                style={{ fontSize: 13, padding: "6px 10px", margin: 0, flex: 1 }}
                placeholder="Ej: Abonó $5.000"
                value={obs}
                onChange={e => setObsLocal(prev => ({ ...prev, [ap.id]: e.target.value }))}
                onKeyDown={e => e.key === "Enter" && guardarObservacion(ap.id)}
              />
              {hayLocal && (
                <button
                  className="btn-icon"
                  style={{ background: "var(--verde)", color: "#fff", borderRadius: 8, padding: "6px 10px", fontSize: 12 }}
                  onClick={() => guardarObservacion(ap.id)}
                >✓</button>
              )}
            </div>
          ) : tieneObs && getPago(ap.id)?.observacion ? (
            <span style={{ fontSize: 13, color: "var(--texto-suave)", fontStyle: "italic" }}>
              {getPago(ap.id).observacion}
            </span>
          ) : (
            <span style={{ color: "var(--gris-borde)", fontSize: 13 }}>—</span>
          )}
        </td>
      </tr>
    )

    return resultado
  })

  return (
    <div style={{ borderTop: "1px solid var(--gris-borde)" }}>
      {apoderadosActivos.length === 0 ? (
        <div style={{ padding: "16px 20px", color: "var(--gris)", fontSize: 13 }}>
          No hay apoderados activos.
        </div>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "var(--verde-bg)" }}>
              <th style={th}>Apoderado</th>
              <th style={th}>Scouts</th>
              <th style={th}>Estado</th>
              <th style={th}>Método de pago</th>
              <th style={th}>Observación</th>
            </tr>
          </thead>
          <tbody>
            {filas}
          </tbody>
        </table>
      )}
    </div>
  )
}

function ModalMonto({ titulo, icono, placeholder, onGuardar, onCerrar }) {
  const [form,      setForm]      = useState({ descripcion: "", monto: "" })
  const [guardando, setGuardando] = useState(false)
  const [error,     setError]     = useState("")

  const guardar = async () => {
    if (!form.descripcion.trim()) { setError("El nombre es obligatorio."); return }
    if (!form.monto || isNaN(form.monto) || +form.monto <= 0) { setError("Ingresa un monto válido."); return }
    setGuardando(true)
    try {
      await onGuardar({
        descripcion: form.descripcion.trim(),
        monto:       parseFloat(form.monto),
        fecha:       { seconds: Math.floor(Date.now() / 1000) },
      })
      onCerrar()
    } catch (err) {
      setError("Error: " + err.message)
    } finally {
      setGuardando(false)
    }
  }

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onCerrar()}>
      <div className="modal-box" style={{ maxWidth: 420 }}>
        <button className="modal-cerrar" onClick={onCerrar}>×</button>
        <h2 className="modal-titulo">{icono} {titulo}</h2>
        <div className="form-group">
          <label className="form-label">Nombre / Descripción</label>
          <input
            className="form-input"
            placeholder={placeholder}
            value={form.descripcion}
            onChange={e => { setForm(f => ({ ...f, descripcion: e.target.value })); setError("") }}
          />
        </div>
        <div className="form-group">
          <label className="form-label">Monto ($)</label>
          <input
            className="form-input" type="number" min="0"
            placeholder="Ej: 15000"
            value={form.monto}
            onChange={e => { setForm(f => ({ ...f, monto: e.target.value })); setError("") }}
            onKeyDown={e => e.key === "Enter" && guardar()}
          />
        </div>
        {error && (
          <div style={{ color: "var(--rojo)", fontSize: 13, marginBottom: 12 }}>⚠ {error}</div>
        )}
        <div className="form-actions">
          <button className="btn-secondary" onClick={onCerrar}>Cancelar</button>
          <button className="btn-primary" onClick={guardar} disabled={guardando}>
            {guardando ? "Guardando..." : "Registrar"}
          </button>
        </div>
      </div>
    </div>
  )
}
  